import { Agent, Channel, getAgentsByChannelId } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';
import { isDeepEqual } from '@/utils/isObjectDeepEqual';

interface UseAgentsDetailsProps {
  selectedChannel: Channel;
}

export const useAgentsDetails = ({ selectedChannel }: UseAgentsDetailsProps) => {
  const { data: agents, loading } = useCache(getAgentsByChannelId, { channelId: selectedChannel.id });

  const sanitizeAgent = (agent: Agent) => {
    const keysToIgnore = ['createdAt', 'updatedAt', 'name', 'username', 'id', 'isBlocked'];
    const sanitizedAgent = agent;
    keysToIgnore.forEach((key) => delete sanitizedAgent[key]);

    return sanitizedAgent;
  };

  const isAddNewAgentAllowed = () => {
    if (agents?.length === 0 || !agents) return false;

    if (agents.length === 1) return true;

    const baseAgent = sanitizeAgent(agents[0]);
    return agents.every((agent) => isDeepEqual(sanitizeAgent(agent), baseAgent));
  };

  return { isAddNewAgentAllowed, loading };
};
